import { Box, Divider, Skeleton } from "@mui/material";
import { ClipLoader } from "react-spinners";
export enum TypeInputLoading {
  Text,
  Radio,
  Editor,
}
const AppFormControlLoading = ({
  count = 1,
  typeInputLoading = TypeInputLoading.Text,
  size = "medium",
}: {
  count?: number;
  typeInputLoading?: TypeInputLoading;
  size?: "medium" | "small";
}) => {
  return (
    // <Box className="flex items-center justify-center cursor-not-allowed w-full h-10 bg-disabled rounded-1">
    //   <ClipLoader color="#1876f2" size={20} />
    // </Box>
    <Box className="relative w-full">
      {/* <ClipLoader
        className="absolute left-1/2 top-1/2 translate-y-1/2 translate-x-1/2"
        color="#1876f2"
        size={20}
      /> */}
      {typeInputLoading === TypeInputLoading.Text &&
        Array.from({ length: count }).map((c, index) => {
          return (
            <Skeleton
              key={index}
              className="w-full rounded-1 transform-none mb-2 last:mb-0"
              sx={{
                height: size === "medium" ? "40px" : "32px",
                transform: "none",
              }}
            />
          );
        })}
      {typeInputLoading === TypeInputLoading.Radio &&
        Array.from({ length: count }).map((c, index) => {
          return (
            <Box
              className="flex gap-3 items-center justify-start mb-4 last:mb-0 first:mt-3 max-w-[300px]"
              key={index}
            >
              <Skeleton className="w-5 h-5  rounded-full transform-none" />
              <Skeleton
                className="w-full h-5 rounded-1 transform-none mb-2 last:mb-0"
                sx={{
                  transform: "none",
                }}
              />
            </Box>
          );
        })}
      {typeInputLoading === TypeInputLoading.Editor &&
        Array.from({ length: count }).map((c, index) => {
          return (
            <Box key={index} className="border border-border p-3 rounded-2">
              <Box className="flex gap-2 items-center flex-wrap justify-start mb-3 last:mb-0">
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                www
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
                <Skeleton className="w-10 h-10  rounded-1 transform-none" />
              </Box>
              <Divider className="mb-5" />
              <Box>
                <Skeleton className="w-[80%] h-15 mb-2 transform-none" />
                <Skeleton className="w-[70%] h-5 mb-2 transform-none" />
                <Skeleton className="w-[90%] h-10 mb-2 transform-none" />
                <Skeleton className="w-[60%] h-15 mb-2 transform-none" />
                <Skeleton className="w-[80%] h-5 mb-2 transform-none" />
              </Box>
            </Box>
          );
        })}
    </Box>
  );
};

export default AppFormControlLoading;
